import React from "react";
import { getWidgetSpecificProps } from "@utils/index";
import { connect } from "react-redux";
import { useOnload } from "@utils/useOnLoad";
import BoxContainer from "@widgets/boxContainer";
import { ExplorePlansButton, NotSureContainer, NotSureContent, NotSureHeading, Price, PriceLabel, StrikeThroughPrice } from "./styles";
import DOMPurify from "isomorphic-dompurify";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import Button from "@widgets/button";

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

const NotSureCard = (props: any) => {
  const {
    text,
    is_visible,
    actions,
    buttonLabel,
    headingText,
    price,
    strikeThroughPrice,
    priceLabel
  } = props;

  const { on_load } = actions || {};

  useOnload({ on_load });

  const handleOnClick = () => {
    const { on_click } = actions || {};
    if (on_click?.length > 0) {
      on_click?.forEach((eachFunc: any) => {
        typeof eachFunc.funCall === "function" &&
          eachFunc.funCall({
            ...eachFunc.args,
            data: {
              ...eachFunc.args?.data,
              event_source: "explore_plans_button"
            }
          });
      });
    }
  };

  return is_visible ? (
    <NotSureContainer>
      <NotSureHeading>{headingText}</NotSureHeading>
      <NotSureContent dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} />
      <Flex
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <Flex
          flexDirection="column"
          alignItems="flex-start"
        >
          <PriceLabel>{priceLabel}</PriceLabel>
          <Flex
            alignItems="flex-end"
            flexDirection="row"
            style={{ gap: "6px" }}
          >
            <Price>₹{price}</Price>
            {strikeThroughPrice && <StrikeThroughPrice>₹{strikeThroughPrice}</StrikeThroughPrice>}
          </Flex>
        </Flex>

        <ExplorePlansButton onClick={handleOnClick}>
          {buttonLabel}
        </ExplorePlansButton>

      </Flex>
    </NotSureContainer>
  ) : (
    <></>
  );
};

export default connect(mapStateToProps)(NotSureCard);